import React, { useState } from 'react';
import { Modal, Box, TextField } from '@mui/material';
import Button from '@/components/CustomButtons/Button';
import { modalStyle } from '@/views/Clients/Claim';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';
import { useTranslation } from 'react-i18next';

export default function ConfirmationModal({
  open,
  onClose,
  onConfirm,
  children,
  showCommentField = false,
  commentLabel,
  commentPlaceholder,
  commentRequired = false,
}) {
  const { t } = useTranslation();
  const [comment, setComment] = useState('');
  const resolvedCommentLabel = commentLabel ?? t('confirmationModal.comment');
  const resolvedCommentPlaceholder =
    commentPlaceholder ?? t('confirmationModal.commentPlaceholder');
  return (
    <Modal
      open={open}
      onClose={() => {
        setComment('');
        onClose(false);
      }}>
      <Box
        sx={modalStyle}
        style={{
          width: '500px',
        }}
        className='makeStyles-card-96'
        noValidate
        autoComplete='off'>
        <CardHeader style={{ transform: 'translateY(-50%)' }} color='primary'>
          <h6>{t('confirmationModal.title')}</h6>
        </CardHeader>
        <CardBody>
          {children}
          {showCommentField && (
            <TextField
              fullWidth
              label={resolvedCommentLabel}
              placeholder={resolvedCommentPlaceholder}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              multiline
              rows={3}
              required={commentRequired}
              variant='outlined'
              style={{ marginTop: '20px' }}
            />
          )}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginTop: '30px',
            }}>
            <Button
              color='rose'
              onClick={() => {
                setComment('');
                onClose(false);
              }}
              type='button'
              variant='contained'>
              {t('confirmationModal.cancel')}
            </Button>
            <Button
              color='primary'
              onClick={() => {
                if (commentRequired && !comment.trim()) {
                  return;
                }
                onConfirm(true, comment);
                setComment('');
              }}
              type='button'
              variant='contained'
              disabled={commentRequired && !comment.trim()}
              style={{ marginLeft: '10px' }}>
              {t('confirmationModal.confirm')}
            </Button>
          </div>
        </CardBody>
      </Box>
    </Modal>
  );
}
